(() => {
  const page = document.querySelector('[data-cart-page]');
  if (!page) return;

  const changeLine = async (line, quantity) => {
    line.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.lineKey, quantity })
      });
      if (!response.ok) throw new Error('Basket update failed');
      window.location.reload();
    } catch (error) {
      line.removeAttribute('aria-busy');
      window.alert('We could not update the basket. Please try again.');
    }
  };

  page.addEventListener('click', (event) => {
    const line = event.target.closest('[data-cart-line]');
    if (!line) return;

    if (event.target.closest('[data-cart-remove]')) {
      changeLine(line, 0);
      return;
    }

    const control = event.target.closest('[data-cart-quantity-change]');
    if (!control) return;
    const input = line.querySelector('[data-cart-quantity] input');
    const next = Math.max(0, Number(input.value || 0) + Number(control.dataset.cartQuantityChange));
    changeLine(line, next);
  });
})();
